import React from "react";
export default function LogoLoader({ height = null }) {
  return (
    <div
      className="loader-container"
      style={{
        height: height ? height : "",
      }}
    >
      <img
        style={{ width: "200px" }}
        src="logotalent.png"
        alt="No Image Available"
        className="logo-loader"
      />
    </div>
  );
}
